import { Box } from "@mui/material"
import StepDescriptionText from "@src/components/StepDescriptionText"
import React from "react"
import NextImage from "./NextImage"
import { height, minWidth } from "@mui/system"

interface StepDescriptionBoxProps {
  iconName: string
  iconSx?: object
  children: React.ReactNode
}

/**
 * Common component for a step box with an icon and description text.
 */
const StepDescriptionBox: React.FC<StepDescriptionBoxProps> = ({
  iconName,
  iconSx,
  children
}) => (
  <Box
    sx={{
      textAlign: "center",
      width: {
        xs: "100%", // Full width on mobile
        sm: "auto" // Auto width on tablet and up
      }
    }}
  >
    <NextImage
      src={`/assets/images/product-additional-Info/${iconName}.svg`}
      sx={{
        "& .next-image-full": {
          position: "relative !important",
          maxWidth: {
            xs: "90px",
            md: "130px"
          },
          height: 'auto !important'
        },
        height: 'auto'
      }}
    />
    <StepDescriptionText
      width={'100%'}
      fontSize={{ 
        xs: '9px',
        md: '14px'
       }}
       lineHeight={{ 
        xs: 'normal'
        }}
    >
      {children}
    </StepDescriptionText>
  </Box>
)

export default StepDescriptionBox
